/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_View_PlayerInputs */



/**
* | output |
* | --- |
* | "Player view" |
*
* @param {Tournament_View_PlayerInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_view_player = /** @type {((inputs?: Tournament_View_PlayerInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_View_PlayerInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vue joueur")
	if (locale === "es") return /** @type {LocalizedString} */ ("Vista de jugador")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Visão de jogador")
	if (locale === "it") return /** @type {LocalizedString} */ ("Vista giocatore")
	return /** @type {LocalizedString} */ ("Player view")
});